"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceType = void 0;
var SpaceType;
(function (SpaceType) {
    SpaceType["LAND"] = "land";
    SpaceType["OCEAN"] = "ocean";
    SpaceType["COLONY"] = "colony";
    SpaceType["LUNAR_MINE"] = "lunar_mine";
    SpaceType["COVE"] = "cove";
})(SpaceType = exports.SpaceType || (exports.SpaceType = {}));
